
import {createSlice} from "@reduxjs/toolkit";


export const subscriberSearchSlice = createSlice({
    name: 'subscriberSearchSlc',
    initialState: {value: {
            id: null,
            externalId: null,
            platformId: null,
            platformName: null,
            service: null,
            countDateFrom: null,
            countDateTo: null,
            subCountFrom: null,
            subCountTo: null,
            source: null
        }},
    reducers:

{
    changeSubscriberSearch: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeSubscriberSearch } = subscriberSearchSlice.actions;

export default  subscriberSearchSlice.reducer ;

